<template>
    <div class="vue-country-filters">
        <div class="inner">
            <span v-html="filterText"></span>

            <div class="filter-wrapper">
                <h3>{{ filterTitle }}</h3>

                <zoa-toggle :title="countriesTitle" v-if="hasCountries">
                    <ul class="country-filter filter-list">
                        <li v-for="country in countries">
                            <zoa-country-filter-buttton
                                :item="country"
                                :event-bus="eventBus"
                                @selected="handleCountryFilterSelected"
                                @deselected="handleCountryFilterDeselected"
                            ></zoa-country-filter-buttton>
                        </li>
                    </ul>
                </zoa-toggle>

                <zoa-toggle :title="specialismsTitle" v-if="hasSpecialisms">
                    <ul class="specialism-filter filter-list">
                        <li v-for="specialism in specialisms">
                            <zoa-country-filter-buttton
                                :item="specialism"
                                :event-bus="eventBus"
                                @selected="handleSpecialismFilterSelected"
                                @deselected="handleSpecialismFilterDeselected"
                            ></zoa-country-filter-buttton>
                        </li>
                    </ul>
                </zoa-toggle>

                <button @click="handleReset" class="reset-btn btn-outline">{{ resetFilters }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CountryFilters",

    props: ['countries', 'eventBus', 'filterText', 'filterTitle', 'resetFilters', 'countriesTitle', 'specialismsTitle'],

    data() {
        return {
            specialisms: [],
            selectedCountries: [],
            selectedSpecialisms: []
        }
    },

    computed: {
        hasCountries() {
            return !_.isEmpty(this.countries);
        },

        hasSpecialisms() {
            return !_.isEmpty(this.specialisms);
        },

        filteredCountries() {
            return _.mapKeys(this.selectedCountries, (country, key) => {
                return country.countrycode;
            });
        },

        filteredCountryCodes() {
            // Als er alleen landen geselecteerd zijn
            if (_.isEmpty(this.selectedSpecialisms) && !_.isEmpty(this.selectedCountries)) {
                return _.keys(this.filteredCountries);
            }

            let countries = [];

            // Als er alleen specialismes geselecteerd zijn
            if (_.isEmpty(this.selectedCountries) && !_.isEmpty(this.selectedSpecialisms)) {
                countries = _.filter(this.countries, (country) => {
                    return ! _.isEmpty(_.filter(_.map(country.specialisms, 'id'), (item) => _.map(this.selectedSpecialisms, 'id').includes(item)));
                });
            }

            // als landen en specialismen geselecteerd zijn
            if (!_.isEmpty(this.filteredCountries)) {
                countries = _.filter(this.filteredCountries, (country) => {
                    return ! _.isEmpty(_.filter(_.map(country.specialisms, 'id'), (item) => _.map(this.selectedSpecialisms, 'id').includes(item)));
                });
            }

            return _.keys(_.mapKeys(countries, (country, key) => {
                return country.countrycode;
            }));
        }
    },

    mounted() {
        this.fetchSpecialisms();
    },

    methods: {
        fetchSpecialisms() {
            axios.get('/api/specialisms')
                .then(response => {
                    this.specialisms = response.data;
                })
                .catch(error => {
                    this.specialisms = [];
                });
        },

        handleReset() {
            this.selectedCountries = [];
            this.selectedSpecialisms = [];

            this.eventBus.$emit('reset-filters');
        },

        handleCountryFilterSelected(country) {
            this.selectedCountries.push(country);
        },

        handleCountryFilterDeselected(country) {
            this.selectedCountries.splice(this.selectedCountries.indexOf(country), 1);
        },

        handleSpecialismFilterSelected(specialism) {
            this.selectedSpecialisms.push(specialism);
        },

        handleSpecialismFilterDeselected(specialism) {
            this.selectedSpecialisms.splice(this.selectedSpecialisms.indexOf(specialism), 1);
        }
    },

    watch: {
        filteredCountryCodes: _.debounce(function(value) {
            let payload;

            payload = {
                data: value,
                results: true
            }

            if (!_.isEmpty(this.selectedCountries) && !_.isEmpty(this.selectedSpecialisms) && _.isEmpty(value)) {
                payload = {results: false};
            }

            this.eventBus.$emit('selected-country-filters', payload);
        }, 200)
    }
}
</script>